module.exports = __webpack_public_path__ + "img/pro_thirteen_10.521fd6e8.jpg";